@if (hasTabs) {
  <div class="nav-tabs">
    <!--Tabs-->
    <div class="nav-tabs-wrapper">
      @for (tab of tabsData | keyvalue: originalOrder; track tab; let index = $index) {
        <a (click)="selectTab(tab.key)"
          [attr.data-cy]="tabsDataCy('nav-tabs-button', index)"
          [class.active]="isActive(tab)"
          class="nav-tabs-button">
          <span [attr.data-cy]="tabsDataCy('nav-tabs-button-text', index)"
          class="nav-tabs-button-text">{{tab.value.title}}</span>
        </a>
      }
    </div>
    <!--Sub Tabs-->
    @for (tab of tabsData | keyvalue: originalOrder; track tab) {
      @if (tab.value.subTabs != null && isActive(tab)) {
        <div class="nav-sub-wrapper">
          @for (subTabs of tab.value.subTabs | keyvalue: originalOrder; track subTabs; let index = $index) {
            <a (click)="selectSubTab(tab.key,subTabs.key)"
              [attr.data-cy]="tabsDataCy('nav-sub-tabs-button', index)"
              [class.active]="isSubTabActive(subTabs)"
              class="nav-sub-tabs-button">
              <div [attr.data-cy]="tabsDataCy('nav-sub-tabs-button-text', index)"
              class="nav-sub-tabs-button-text">{{subTabs.value.title}}</div>
            </a>
          }
        </div>
      }
      <!--Content-->
      @if (tab.value.subTabs != null && isActive(tab)) {
        @for (subTab of tab.value.subTabs | keyvalue: originalOrder; track subTab) {
          @if (isSubTabActive(subTab)) {
            <ng-container
            *ngTemplateOutlet="tabContentTemplate; context: {content: subTab.value.contentTemplate, key: subTab.key}"></ng-container>
          }
        }
      }
    }
  </div>
}

<ng-template #tabContentTemplate let-content="content" let-key="key">
  <div [attr.data-cy]="tabsDataCy('tab-content', key)" class="tab-content">
    <ng-container *ngTemplateOutlet=content></ng-container>
  </div>
</ng-template>
